module.exports = __webpack_public_path__ + "img/2.950f7a1e.webp";